module.exports = __webpack_public_path__ + "img/content.431fef33.png";